import { MakeCall } from './createMakeCall';
import { ListingVideo } from './types/Listing';

const getListingVideos = (makeCall: MakeCall) => (listingId: number) =>
  makeCall<ListingVideo[]>('GET', `/api/v2/listing/${listingId}/videos`);
export { getListingVideos };
